// import React, { useState, useEffect } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import { z } from "zod";
// import { FaCheckCircle } from "react-icons/fa";
// import { HiEye, HiEyeOff } from "react-icons/hi";
// import "react-toastify/dist/ReactToastify.css";
// import { useNavigate } from "react-router-dom";
// import Cookies from "js-cookie"; // Import the cookies library

// const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;

// const decodeJWT = (token) => {
//   try {
//     if (!token) return null;

//     const base64Url = token.split(".")[1];
//     const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
//     const jsonPayload = decodeURIComponent(
//       atob(base64)
//         .split("")
//         .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
//         .join("")
//     );
//     return JSON.parse(jsonPayload);
//   } catch (error) {
//     console.error("Failed to decode token:", error);
//     return null;
//   }
// };
// const passwordSchema = z
//   .object({
//     currentPassword: z.string().nonempty("Current password is required."),
//     password: z
//       .string()
//       .nonempty("Password is required.")
//       .min(8, "At least 8 characters are required.")
//       .max(16, "The password must be a maximum of 16 characters.")
//       .regex(/[A-Z]/, "Password must contain at least one uppercase letter.")
//       .regex(
//         /[!@#$%^&*(),.?":{}|<>]/,
//         "Password must contain at least one special character."
//       )
//       .regex(/\d/, "Password must contain at least one number."),
//     confirmPassword: z.string(),
//   })
//   .refine((data) => data.password === data.confirmPassword, {
//     message: "Passwords do not match.",
//     path: ["confirmPassword"],
//   });

// const Profile = () => {
//   const [user, setUser] = useState({
//     email: "",
//     name: "",
//   });
//   const [currentPassword, setCurrentPassword] = useState(""); // Current password state
//   const [password, setPassword] = useState(""); // New password state
//   const [confirmPassword, setConfirmPassword] = useState(""); // Confirm password state
//   const [showPassword, setShowPassword] = useState(false); // Show password state
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Show confirm password state
//   const [showCurrentPassword, setShowCurrentPassword] = useState(false); // Show current password state
//   const [errors, setErrors] = useState({}); // Error state
//   const [isPasswordSet, setIsPasswordSet] = useState(false); // Flag to track password status
//   const [showModal, setShowModal] = useState(false); // Modal state for success popup
//   const navigate = useNavigate();

//   useEffect(() => {
//     // Get token from cookies
//     const token = Cookies.get("access_token");

//     if (token) {
//       const decodedToken = decodeJWT(token);
//       console.log("Decoded token:", decodedToken); // For debugging

//       if (decodedToken) {
//         setUser({
//           email: decodedToken.email || "",
//           name: `${decodedToken.first_name || ""} ${
//             decodedToken.last_name || ""
//           }`.trim(),
//           first_name: decodedToken.first_name || "",
//           last_name: decodedToken.last_name || "",
//           roles: decodedToken.roles || "",
//           permissions: decodedToken.permissions || "",
//         });

//         // Also store in localStorage if needed
//         localStorage.setItem(
//           "user",
//           JSON.stringify({
//             email: decodedToken.email,
//             name: `${decodedToken.first_name} ${decodedToken.last_name}`.trim(),
//           })
//         );
//       }
//     } else {
//       // Fallback to localStorage if cookie not found
//       const storedUser = JSON.parse(localStorage.getItem("user"));
//       if (storedUser) {
//         setUser(storedUser);
//       }
//     }
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Clear previous errors
//     setErrors({});

//     try {
//       // Validate the form fields using the schema
//       passwordSchema.parse({ currentPassword, password, confirmPassword });

//       // Make API call to update password
//       const response = await fetch(`${AQ_BASE_URL}/aq/api/updatePassword`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           accept: "application/json",
//         },
//         body: JSON.stringify({
//           email: user.email,
//           current_password: currentPassword,
//           new_password: password,
//           confirm_password: confirmPassword,
//         }),
//       });

//       const data = await response.json();
//       console.log(data);
//       if (data.success) {
//         // Show success message and reset password fields
//         toast.success("Password has been updated successfully!");
//         setIsPasswordSet(true);
//         setShowModal(true); // Show the success modal

//         // Clear input fields after successful update
//         setCurrentPassword("");
//         setPassword("");
//         setConfirmPassword("");

//         navigate("/dashboard/system-config/wide-settings");
//       } else {
//         // Show error if update fails
//         toast.error(data.message || "Something went wrong. Please try again.");
//       }
//     } catch (error) {
//       // Handle Zod validation errors
//       if (error instanceof z.ZodError) {
//         const fieldErrors = error.flatten().fieldErrors;
//         setErrors({
//           currentPassword: fieldErrors.currentPassword?.[0] || "",
//           password: fieldErrors.password?.[0] || "",
//           confirmPassword: fieldErrors.confirmPassword?.[0] || "",
//         });
//       } else {
//         toast.error("Something went wrong. Please try again.");
//       }
//     }
//   };

//   const closeModal = () => {
//     setShowModal(false); // Close the modal
//   };

//   return (
//     <div>
//       <p className="text-gray-500 font-semibold mb-6">
//         Allows users to view their personal details.
//       </p>
//       <div className="flex flex-col md:flex-row w-full bg-gray-50 mt-5">
//         <div className="flex flex-col items-center w-full  md:w-1/3 mb-6 md:mb-0 bg-white border-r-2">
//           <div className="w-52 h-48 m-6 flex items-center justify-center bg-black text-white text-6xl font-bold">
//             {user.name ? user.name.charAt(0).toUpperCase() : "J"}
//           </div>
//           <h1 className="text-base text-left">
//             <span className="text-black font-semibold">Name :</span>{" "}
//             {user.name ? user.name : "John Doe"}
//           </h1>
//           <p className="text-sm text-gray-600 text-left">
//             <span className="font-semibold text-black">Email:</span>{" "}
//             {user.email ? user.email : "example@example.com"}
//           </p>
//         </div>

//         <div className="w-full md:w-2/3 flex flex-col bg-white p-6 rounded-md">
//           <h2 className="text-lg font-semibold mb-2 text-gray-700">
//             Update Password
//           </h2>

//           <form onSubmit={handleSubmit}>
//             <div className="mb-2">
//               <label
//                 htmlFor="currentPassword"
//                 className="block text-sm font-medium text-gray-700"
//               >
//                 Current Password
//               </label>
//               <div className="relative">
//                 <input
//                   type={showCurrentPassword ? "text" : "password"}
//                   id="currentPassword"
//                   value={currentPassword}
//                   onChange={(e) => setCurrentPassword(e.target.value)}
//                   className={`w-full px-4 py-2 border placeholder:text-xs text-xs ${
//                     errors.currentPassword
//                       ? "border-red-500"
//                       : "border-gray-300"
//                   } rounded-md`}
//                   placeholder="Enter current password"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowCurrentPassword(!showCurrentPassword)}
//                   className="absolute inset-y-0 right-3 flex items-center text-black"
//                 >
//                   {showCurrentPassword ? (
//                     <HiEye size={16} className="text-black" />
//                   ) : (
//                     <HiEyeOff size={16} />
//                   )}
//                 </button>
//               </div>
//               {errors.currentPassword && (
//                 <p className="text-red-500 text-xs">{errors.currentPassword}</p>
//               )}
//             </div>

//             <div className="mb-2">
//               <label
//                 htmlFor="password"
//                 className="block text-sm font-medium text-gray-700"
//               >
//                 New Password
//               </label>
//               <div className="relative">
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   id="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   className={`w-full px-4 py-2 border placeholder:text-xs text-xs ${
//                     errors.password ? "border-red-500" : "border-gray-300"
//                   } rounded-md`}
//                   placeholder="Enter new password"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPassword(!showPassword)}
//                   className="absolute inset-y-0 right-3 flex items-center text-black"
//                 >
//                   {showPassword ? (
//                     <HiEye size={16} className="text-black" />
//                   ) : (
//                     <HiEyeOff size={16} />
//                   )}
//                 </button>
//               </div>
//               {errors.password && (
//                 <p className="text-red-500 text-xs">{errors.password}</p>
//               )}
//             </div>

//             <div className="mb-2">
//               <label
//                 htmlFor="confirmPassword"
//                 className="block text-sm font-medium text-gray-700"
//               >
//                 Confirm Password
//               </label>
//               <div className="relative">
//                 <input
//                   type={showConfirmPassword ? "text" : "password"}
//                   id="confirmPassword"
//                   value={confirmPassword}
//                   onChange={(e) => setConfirmPassword(e.target.value)}
//                   className={`w-full px-4 py-2 border placeholder:text-xs text-xs ${
//                     errors.confirmPassword
//                       ? "border-red-500"
//                       : "border-gray-300"
//                   } rounded-md`}
//                   placeholder="Re-enter new password"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                   className="absolute inset-y-0 right-3 flex items-center text-black"
//                 >
//                   {showConfirmPassword ? (
//                     <HiEye size={16} className="text-black" />
//                   ) : (
//                     <HiEyeOff size={16} />
//                   )}
//                 </button>
//               </div>
//               {errors.confirmPassword && (
//                 <p className="text-red-500 text-xs">{errors.confirmPassword}</p>
//               )}
//             </div>

//             <div className="flex justify-center mt-6">
//               <button
//                 type="submit"
//                 className="bg-cyan-500 text-white hover:text-black py-2 px-20 rounded-md flex items-center"
//               >
//                 Reset Password
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>

//       {/* Success Modal */}
//       {showModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
//           <div className="bg-white p-8 rounded-xl shadow-2xl max-w-md w-full mx-4 text-center animate-fade-in-up">
//             <div className="flex justify-center mb-6">
//               <FaCheckCircle
//                 size={60}
//                 className="text-green-500 animate-bounce"
//               />
//             </div>

//             <h3 className="text-2xl font-semibold text-gray-800 mb-2">
//               Password Updated Successfully!
//             </h3>
//             <p className="text-gray-600 mb-8">
//               You can now log in with your new password.
//             </p>

//             <button
//               className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 text-white py-3 px-6 rounded-lg text-lg font-medium hover:shadow-lg "
//               onClick={closeModal}
//             >
//               Done
//             </button>
//           </div>
//         </div>
//       )}

//       <ToastContainer />
//     </div>
//   );
// };

// export default Profile;

import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { z } from 'zod';
import { FaCheckCircle } from 'react-icons/fa';
import { HiEye, HiEyeOff } from 'react-icons/hi';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'; // Import the cookies library
import { getCurrentUser } from '.././Authentication/auth.jsx'; // Adjust import path as needed

const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;

const decodeJWT = (token) => {
  try {
    if (!token) return null;

    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Failed to decode token:', error);
    return null;
  }
};
const passwordSchema = z
  .object({
    currentPassword: z.string().nonempty('Current password is required.'),
    password: z
      .string()
      .nonempty('Password is required.')
      .min(8, 'At least 8 characters are required.')
      .max(16, 'The password must be a maximum of 16 characters.')
      .regex(/[A-Z]/, 'Password must contain at least one uppercase letter.')
      .regex(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character.')
      .regex(/\d/, 'Password must contain at least one number.'),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match.',
    path: ['confirmPassword'],
  });

const Profile = () => {
  const [user, setUser] = useState({
    email: '',
    name: '',
  });
  const [currentPassword, setCurrentPassword] = useState(''); // Current password state
  const [password, setPassword] = useState(''); // New password state
  const [confirmPassword, setConfirmPassword] = useState(''); // Confirm password state
  const [showPassword, setShowPassword] = useState(false); // Show password state
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Show confirm password state
  const [showCurrentPassword, setShowCurrentPassword] = useState(false); // Show current password state
  const [errors, setErrors] = useState({}); // Error state
  const [isPasswordSet, setIsPasswordSet] = useState(false); // Flag to track password status
  const [showModal, setShowModal] = useState(false); // Modal state for success popup
  const navigate = useNavigate();
  const [isMfaEnabled, setIsMfaEnabled] = useState(false);
  const [isLoadingMfa, setIsLoadingMfa] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      const currentUser = await getCurrentUser();
      if (currentUser) {
        setUser({
          email: currentUser.email,
          name: `${currentUser.first_name || ''} ${currentUser.last_name || ''}`.trim(),
        });

        // Fetch current 2FA status
        try {
          const res = await fetch(`${AQ_BASE_URL}/aq/api/get-2fa-status/${currentUser.email}`);
          const data = await res.json();
          if (data.status === 'success') {
            setIsMfaEnabled(data.mfa_enabled);
          }
        } catch (error) {
          console.error('Failed to fetch 2FA status:', error);
          toast.error('Failed to fetch 2FA status.');
        } finally {
          setIsLoadingMfa(false);
        }
      } else {
        toast.error('Failed to fetch user data. Please log in again.');
        navigate('/login');
      }
    };

    fetchUser();
  }, [navigate]);

  const handleToggleMfa = async () => {
    try {
      const response = await fetch(`${AQ_BASE_URL}/aq/api/toggle-2fa`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
        body: JSON.stringify({
          email: user.email,
          enable: !isMfaEnabled,
        }),
      });

      const data = await response.json();

      if (data.status === 'success') {
        setIsMfaEnabled(data.mfa_enabled);
        toast.success(`2FA has been ${data.mfa_enabled ? 'enabled' : 'disabled'}`);
      } else {
        toast.error(data.message || 'Failed to toggle 2FA.');
      }
    } catch (error) {
      console.error('Toggle 2FA error:', error);
      toast.error('Something went wrong. Try again!');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Clear previous errors
    setErrors({});

    try {
      // Validate the form fields using the schema
      passwordSchema.parse({ currentPassword, password, confirmPassword });

      // Make API call to update password
      const response = await fetch(`${AQ_BASE_URL}/aq/api/updatePassword`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
        body: JSON.stringify({
          email: user.email,
          current_password: currentPassword,
          new_password: password,
          confirm_password: confirmPassword,
        }),
      });

      const data = await response.json();
      console.log(data);
      if (data.success) {
        // Show success message and reset password fields
        toast.success('Password has been updated successfully!');
        setIsPasswordSet(true);
        setShowModal(true); // Show the success modal

        // Clear input fields after successful update
        setCurrentPassword('');
        setPassword('');
        setConfirmPassword('');

        navigate('/dashboard/system-config/wide-settings');
      } else {
        // Show error if update fails
        toast.error(data.message || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      // Handle Zod validation errors
      if (error instanceof z.ZodError) {
        const fieldErrors = error.flatten().fieldErrors;
        setErrors({
          currentPassword: fieldErrors.currentPassword?.[0] || '',
          password: fieldErrors.password?.[0] || '',
          confirmPassword: fieldErrors.confirmPassword?.[0] || '',
        });
      } else {
        toast.error('Something went wrong. Please try again.');
      }
    }
  };

  const closeModal = () => {
    setShowModal(false); // Close the modal
  };

  return (
    <div>
      <p className="text-gray-500 font-semibold mb-6">
        Allows users to view their personal details.
      </p>
      <div className="flex flex-col md:flex-row w-full bg-gray-50 mt-5">
        <div className="flex flex-col items-center w-full  md:w-1/3 mb-6 md:mb-0 bg-white border-r-2">
          <div className="w-52 h-48 m-6 flex items-center justify-center bg-black text-white text-6xl font-bold">
            {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
          </div>
          <h1 className="text-base text-left">
            <span className="text-black font-semibold">Name :</span> {user.name || 'Unknown'}
          </h1>
          <p className="text-sm text-gray-600 text-left">
            <span className="font-semibold text-black">Email:</span>{' '}
            {user.email || 'unknown@example.com'}
          </p>
        </div>

        <div className="w-full md:w-2/3 flex flex-col bg-white p-6 rounded-md">
          <h2 className="text-lg font-semibold mb-2 text-gray-700">Update Password</h2>

          <form onSubmit={handleSubmit}>
            <div className="mb-2">
              <label htmlFor="currentPassword" className="block text-sm font-medium text-gray-700">
                Current Password
              </label>
              <div className="relative">
                <input
                  type={showCurrentPassword ? 'text' : 'password'}
                  id="currentPassword"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  className={`w-full px-4 py-2 border placeholder:text-xs text-xs ${
                    errors.currentPassword ? 'border-red-500' : 'border-gray-300'
                  } rounded-md`}
                  placeholder="Enter current password"
                />
                <button
                  type="button"
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                  className="absolute inset-y-0 right-3 flex items-center text-black"
                >
                  {showCurrentPassword ? (
                    <HiEye size={16} className="text-black" />
                  ) : (
                    <HiEyeOff size={16} />
                  )}
                </button>
              </div>
              {errors.currentPassword && (
                <p className="text-red-500 text-xs">{errors.currentPassword}</p>
              )}
            </div>

            <div className="mb-2">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                New Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={`w-full px-4 py-2 border placeholder:text-xs text-xs ${
                    errors.password ? 'border-red-500' : 'border-gray-300'
                  } rounded-md`}
                  placeholder="Enter new password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-3 flex items-center text-black"
                >
                  {showPassword ? (
                    <HiEye size={16} className="text-black" />
                  ) : (
                    <HiEyeOff size={16} />
                  )}
                </button>
              </div>
              {errors.password && <p className="text-red-500 text-xs">{errors.password}</p>}
            </div>

            <div className="mb-2">
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                Confirm Password
              </label>
              <div className="relative">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className={`w-full px-4 py-2 border placeholder:text-xs text-xs ${
                    errors.confirmPassword ? 'border-red-500' : 'border-gray-300'
                  } rounded-md`}
                  placeholder="Re-enter new password"
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute inset-y-0 right-3 flex items-center text-black"
                >
                  {showConfirmPassword ? (
                    <HiEye size={16} className="text-black" />
                  ) : (
                    <HiEyeOff size={16} />
                  )}
                </button>
              </div>
              {errors.confirmPassword && (
                <p className="text-red-500 text-xs">{errors.confirmPassword}</p>
              )}
            </div>

            <div className="flex justify-center mt-6">
              <button
                type="submit"
                className="bg-black text-white hover:bg-gray-800 py-2 px-20 rounded-md flex items-center"
              >
                Reset Password
              </button>
            </div>
          </form>

          {/* 2FA Toggle Section */}
          <div className="mt-10">
            <h2 className="text-lg font-semibold mb-1 text-gray-700">
              Two-Factor Authentication (2FA)
            </h2>
            <p className="text-sm text-gray-500 mb-4">
              Enhance the security of your account by requiring an additional verification step
              during login.
            </p>
            {isLoadingMfa ? (
              <p className="text-gray-500 text-sm">Loading 2FA status...</p>
            ) : (
              <div className="flex items-center justify-between">
                <span className="text-gray-700 text-sm">
                  {isMfaEnabled ? '2FA is Enabled' : '2FA is Disabled'}
                </span>
                <button
                  onClick={handleToggleMfa}
                  className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors duration-300 ${
                    isMfaEnabled ? 'bg-black' : 'bg-gray-300'
                  }`}
                >
                  <span
                    className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform duration-300 ${
                      isMfaEnabled ? 'translate-x-6' : 'translate-x-1'
                    }`}
                  />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Success Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
          <div className="bg-white p-8 rounded-xl shadow-2xl max-w-md w-full mx-4 text-center animate-fade-in-up">
            <div className="flex justify-center mb-6">
              <FaCheckCircle size={60} className="text-green-500 animate-bounce" />
            </div>

            <h3 className="text-2xl font-semibold text-gray-800 mb-2">
              Password Updated Successfully!
            </h3>
            <p className="text-gray-600 mb-8">You can now log in with your new password.</p>

            <button
              className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 text-white py-3 px-6 rounded-lg text-lg font-medium hover:shadow-lg "
              onClick={closeModal}
            >
              Done
            </button>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default Profile;
